import APIService from '@/services/APIService.js';

export default {
  getExpurgos() {
    return APIService.apiCall().get(`/georreferenciadoExpurgos/getExpurgosGeorreferenciado`);
  },
  deletar(id) {
    return APIService.apiCall().get(`/georreferenciadoExpurgos/delete/${id}`);
  },
  getDatesAndRegistersImportedEntities() {
    return APIService.apiCall().get('/georreferenciadoExpurgos/getDatesAndRegistersImportedEntities');
  },
  getEntitiesByDates(datas, versoes) {
    return APIService.apiCall().post(`/georreferenciadoExpurgos/getEntitiesByDates/${datas}/${versoes}`, JSON.stringify(datas));
  },
  salvar(postData) {
    return APIService.apiCall().post(`/georreferenciadoExpurgos/salvarExpurgo`, JSON.stringify(postData));
  }
};
